module.exports = __webpack_public_path__ + "static/media/mcv__bg.fda25a68.jpg";